export const convertToJSON = <T>(data: Uint8Array): T => {
  return JSON.parse(new TextDecoder().decode(data));
};
